/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-12-09 18:35:56
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:23:31
 */
export default [
  {
    path: '/sale-analysis',
    name: 'sale-analysis',
    meta: {
      name: '销售概览',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'@/views/operation/sale-analysis/index.vue')
  },
  {
    path: '/month-profits',
    name: 'month-profits',
    meta: {
      name: '利润月报',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'@/views/operation/month-profits/index.vue')
  },
  {
    path: '/performance-board',
    name: 'performance-board',
    meta: {
      name: '行为分析',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'@/views/operation/performance-board/index.vue')
  },
  {
    path: '/customer-profits',
    name: 'customer-profits',
    meta: {
      name: '顾客概览',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'@/views/operation/customer-profits/index.vue')
  },
  {
    path: '/merits-board',
    name: 'merits-board',
    meta: {
      name: '绩效看板',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */ '@/views/operation/merits-board/index.vue')
  },
  {
    path: '/merits-board-detail',
    name: 'merits-board-detail',
    meta: {
      name: '绩效详情',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */ '@/views/operation/merits-board/detail.vue')
  },
]
